module.exports = __webpack_public_path__ + "img/banner3.015d993d.png";